import { useProfile } from "../components/ProfileContext";
import { Row, Col, Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ProfileNavDropDown } from "./ProfileNavDropdown";
import { ProfileActiveJobDisplay } from "./ProfileActiveJobDisplay";
import vault_logo from "../images/vault_logo.png"
import powered_by from "../images/powered_by.png"

export function ProfileBarVault(props) {
	let [profile] = useProfile();

    return (
		<div>
			<div className="profile-bar mt-0 ps-3 navbar navbar-default sticky-top vault-topbar">
				<div style={{width:"100%"}} className="mx-2">
					{(profile == null) && <div className="not-logged-in">
						Not Logged In
						<Button variant="success" className="m-2" size="sm" onClick={login}>Login</Button>
					</div>}
					
					<ProfileActiveJobDisplay className="mx-2" />

					{(profile != null) && <div className="float-end"><ProfileNavDropDown showFullName={true} className="m-2" /></div>}
					<div className="float-end vault-topbar-links d-none d-md-block">
						<ul>
							<li><a href="http://www.mcelroy.com/en/distributorlocator.htm" target="_blank">Buy Equipment</a></li>
							<li><a href="http://www.mcelroy.com/en/rentequipment.htm" target="_blank">Rent Equipment</a></li>
							<li><a href="http://fusion.mcelroy.com/parts/exec" target="_blank">Parts Finder</a></li>
							<li><a href="http://sales.mcelroy.com/apps/index.htm/default" target="_blank">Distributor Login</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="vault-underbar ps-4 pt-1">
				<a href="/apps/vault/"><img src={vault_logo} height="41" className="float-start" /></a>
				<ul className="d-none d-sm-block">
					<li><Link to="/jobs">Jobs</Link></li>
					<li><Link to="/inspections">Inspections</Link></li>
					<li><Link to="/assets">Assets</Link></li>
					<li><Link to="/parts">Parts</Link></li>
				</ul>
				<img src={powered_by} height="41" className="float-end pt-1 d-none d-md-block me-4" />
				<div className="clearfix"></div>
			</div>
			<div className="m-4"></div>
		</div>
    );
}